/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Pit2_DInputs */

const en_csv_to_json_pit2_d = /** @type {(inputs: Csv_To_Json_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tab separated and semicolon separated files are not parsed. Semicolons are common in exports from European locale spreadsheets, where the comma is the decimal separator. Re-export as comma separated, or replace the delimiter first, being careful not to touch delimiters that appear inside quoted fields.`)
};

const ko_csv_to_json_pit2_d = /** @type {(inputs: Csv_To_Json_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`탭 구분과 세미콜론 구분 파일은 파싱되지 않습니다. 세미콜론은 쉼표를 소수점 구분자로 쓰는 유럽 로케일 스프레드시트의 내보내기에서 흔합니다. 쉼표 구분으로 다시 내보내거나, 먼저 구분자를 바꾸세요. 인용 필드 안에 나타나는 구분자는 건드리지 않도록 주의해야 합니다.`)
};

const ja_csv_to_json_pit2_d = /** @type {(inputs: Csv_To_Json_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タブ区切りとセミコロン区切りのファイルはパースされません。セミコロンは、カンマを小数点区切りに使うヨーロッパロケールの表計算のエクスポートでよく見られます。カンマ区切りで再エクスポートするか、先に区切り文字を置き換えてください。引用フィールド内に現れる区切り文字に触れないよう注意が必要です。`)
};

/**
* | output |
* | --- |
* | "Tab separated and semicolon separated files are not parsed. Semicolons are common in exports from European locale spreadsheets, where the comma is the decima..." |
*
* @param {Csv_To_Json_Pit2_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_pit2_d = /** @type {((inputs?: Csv_To_Json_Pit2_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Pit2_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_pit2_d(inputs)
	if (locale === "ko") return ko_csv_to_json_pit2_d(inputs)
	return ja_csv_to_json_pit2_d(inputs)
});